import React from 'react';

import { Box, Typography } from '@mui/joy';

export interface DroneTelemetryProps {
  distanceToHome: number; // feet
  horizontalSpeed: number; // MPH
  verticalSpeed: number; // MPH
}

const ValueBlock: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <Box className='text-center'>
    <Typography level='body-md' className='font-bold'>
      {value}
    </Typography>
    <Typography level='body-xs' className='uppercase tracking-wide text-neutral-300'>
      {label}
    </Typography>
  </Box>
);

const DroneTelemetry: React.FC<DroneTelemetryProps> = ({ distanceToHome, horizontalSpeed, verticalSpeed }) => (
  <Box className='flex space-x-4'>
    <ValueBlock label='FT HOME' value={distanceToHome.toFixed(0)} />
    <ValueBlock label='H SPEED' value={horizontalSpeed.toFixed(1)} />
    <ValueBlock label='V SPEED' value={verticalSpeed.toFixed(1)} />
  </Box>
);

export default DroneTelemetry;
